export default __webpack_public_path__ + "static/media/dwarf.62621b10.svg";